import { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ChartContainer } from '../../../../../common/chart/chartContainer'
import Bar from '../../../../../common/chart/chartContainer/Bar'
import { Legend } from '../../../../../common/chart/legend'
import { Element } from '../../../../../common/html/element'
import { SCREEN } from '../../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../../common/selectCurrencyUnit/useFormatCurrency'
import { getUnique } from '../../../../../helpers/common'
import { convertData, isInValidValue } from '../../../../../helpers/value'
import { selectUserType } from '../../../../../layout/store/slice'
import { USER_TYPE } from '../../../../../utils/authorization'
import {
  getNoDataComponent,
  getStyleHeightContainer,
  getValueAndTitleCheckbox,
  handleIconDownload,
} from '../../helper'
import classes from '../../index.module.scss'
import { changeChecked, selectChecked } from '../../store/slice'
import { TREND_DATA } from './constant'
import { selectDataViewByTrend, selectIndicatorById } from './store/slice'

const Trend = ({ id, isDynamicReport, check, isDownloadComponent }) => {
  const chartId = useRef(getUnique())

  const dispatch = useDispatch()
  const userType = useSelector(selectUserType)
  const {
    formatedUnit,
    getExchangeRate,
    multiplier,
    formatValueWithUnit,
    decimalLength,
  } = useFormatCurrency(SCREEN.FINANCIAL_ANALYSIS)
  const dataByTrend = useSelector(selectDataViewByTrend)
  const indicatorById = useSelector(selectIndicatorById)
  const checkedStore = useSelector(selectChecked(id))

  const checked = checkedStore || check

  const setChecked = (checked) => dispatch(changeChecked({ id, checked }))

  const dataConvert = convertData(
    dataByTrend,
    getExchangeRate,
    indicatorById,
    multiplier,
    ['year'],
  )
  const checkboxs = TREND_DATA.map((item) => ({
    ...item,
    ...getValueAndTitleCheckbox(indicatorById, item.value),
  }))

  const barChecked = checkboxs.filter((item) => checked.includes(item.value))
  const groupStackBarKeys = barChecked.map((bar) => bar.value)

  const isNoData = !dataConvert.length

  useEffect(() => {
    handleIconDownload(id, isNoData)
  }, [isNoData])

  if (isNoData) {
    return getNoDataComponent(isDynamicReport)
  }

  return (
    <div
      style={{
        height: getStyleHeightContainer(isDynamicReport, isNoData, 332),
      }}
      className="dFlex"
    >
      <div className="flexColumn w60 h100">
        <Element className={`${classes.mt6}`} style={{ color: '#9C9C9C' }}>
          {formatedUnit}
        </Element>
        <ChartContainer
          chartId={chartId.current}
          data={dataConvert}
          margin={{
            bottom: 0,
            left: isDownloadComponent || isDynamicReport ? 16 : 0,
            right: 0,
          }}
          width="100%"
          height="100%"
          xAxis={[{ dataKey: 'year' }]}
          yAxis={[
            {
              yAxisId: 'left',
              dataKeys: barChecked.map((item) => item.value),
              isStackedBar: true,
              decimalLength,
            },
          ]}
          tooltip={{
            schema: {
              content: barChecked.map((bar) => ({
                dataKey: bar.value,
                label: bar.title,
                formatValue: (value) => formatValueWithUnit({ value }),
              })),
            },
          }}
        >
          {barChecked.map((bar, barIndex) => (
            <Bar
              key={bar.value}
              yAxisId="left"
              dataKey={bar.value}
              fill={bar.color}
              stackId="stack"
              maxBarSize={25}
              showLabelEmpty={({ index }) =>
                barIndex === 0 &&
                groupStackBarKeys.every((dataKey) =>
                  isInValidValue(dataConvert[index][dataKey]),
                )
              }
            />
          ))}
        </ChartContainer>
      </div>
      <div className="h100 w40 pl2 dFlex alignItemsCenter justifyContentCenter">
        <Legend
          chartId={chartId.current}
          items={checkboxs.map((item) => ({
            title: item.title,
            value: item.value,
            dataKey: item.value,
            color: item.color,
            isCheckbox: userType?.userTypeId === USER_TYPE.PREMIUM,
            listCheckBox: checked,
            setListCheckBox: setChecked,
            isI18n: false,
            isDynamicReport: isDynamicReport || isDownloadComponent,
          }))}
          className="flexColumn"
        />
      </div>
    </div>
  )
}

export default Trend
